import "@/App.css";
import FokusPratzen from "@/game/FokusPratzen";

function App() {
  return <FokusPratzen />;
}

export default App;
